/** Permissive host check — `acme.com`, `www.acme.co.uk`, `https://acme.com/x?y=1` all pass. */
const WEBSITE_RE = /^(https?:\/\/)?[a-z0-9-]+(\.[a-z0-9-]+)+(:\d+)?([/?#]\S*)?$/i;

export const isValidWebsite = (value: string) => WEBSITE_RE.test(value.trim());

/**
 * A clickable href for a stored website. Values are persisted exactly as typed,
 * so the scheme is added here rather than mutating what the user entered.
 */
export const toWebsiteHref = (value: string) => {
  const v = value.trim();
  if (!v) return '';
  return /^https?:\/\//i.test(v) ? v : `https://${v}`;
};

/** Strips the scheme and any trailing slash for display. */
export const toWebsiteLabel = (value: string) =>
  value.trim().replace(/^https?:\/\//i, '').replace(/\/$/, '');
